module.exports = __webpack_public_path__ + "static/location-koalas-c1f39c9293de26f10910bff6fa72fe1c.png";